import { isAdminOrHrRole, isGodMode } from './adminRoles';

const SYSTADMIN_RU = 'Системный администратор';
const SYSTADMIN_UA = 'Системний адміністратор';

/** Директор / руководитель — как в сайдбаре */
export function isDirectorRole(role, user) {
  if (isGodMode(user)) return true;
  const r = String(role ?? '')
    .trim()
    .toLowerCase();
  return r === 'director' || r === 'директор' || r === 'руководитель';
}

export function hasSystemAdministratorDepartmentAccess(user) {
  const access = user?.departments_access;
  if (!Array.isArray(access)) return false;
  return access.some((d) => {
    const s = String(d || '').trim();
    return s === SYSTADMIN_RU || s === SYSTADMIN_UA;
  });
}

/**
 * Кнопка «Бот» в Управлении: директор, админ, HR по роли;
 * остальные — только при «Системный администратор» в доступе к отделам.
 */
export function canAccessTelegramBotSettings(user) {
  if (!user) return false;
  if (isGodMode(user)) return true;
  if (isDirectorRole(user.role, user)) return true;
  if (isAdminOrHrRole(user.role, user)) return true;
  return hasSystemAdministratorDepartmentAccess(user);
}
